// Os estilos da interface. Saiu do App.js em 03/11/2026, inteiro e
// sem uma linha alterada: sao valores de CSS, nao dependem de nada
// e so estavam ali por inercia.
export const s = {
  bg: {
    maxWidth:480, margin:"0 auto",
    paddingTop:"calc(16px + env(safe-area-inset-top))", paddingRight:"14px", paddingBottom:"16px", paddingLeft:"14px",
    fontFamily:"'Georgia', 'Times New Roman', serif",
    background:"linear-gradient(160deg, #07080f 0%, #0c0e1a 50%, #080d14 100%)",
    minHeight:"100vh", color:"#e2e8f0",
    backgroundAttachment:"fixed"
  },
  center: {display:"flex", justifyContent:"center", alignItems:"center", height:"100vh", background:"#07080f"},
  loginBg: {
    display:"flex", justifyContent:"center", alignItems:"center",
    minHeight:"100vh",
    background:"radial-gradient(ellipse at 50% 0%, #0f1f3d 0%, #07080f 70%)"
  },
  loginCard: {
    textAlign:"center", padding:"40px 32px",
    background:"linear-gradient(145deg, #0d1525, #111827)",
    borderRadius:24, maxWidth:340, width:"90%",
    border:"1px solid rgba(99,102,241,0.2)",
    boxShadow:"0 25px 60px rgba(0,0,0,0.6), 0 0 40px rgba(99,102,241,0.05)"
  },
  loginSub: {
    color:"#64748b", marginBottom:28, fontSize:13,
    fontFamily:"'Georgia', serif", fontStyle:"italic", lineHeight:1.6
  },
  googleBtn: {
    background:"linear-gradient(135deg, #4f46e5, #7c3aed)",
    color:"#fff", border:"none", padding:"15px 24px",
    borderRadius:12, fontSize:15, cursor:"pointer", width:"100%",
    marginBottom:16, fontFamily:"'Georgia', serif",
    boxShadow:"0 4px 20px rgba(99,102,241,0.4)",
    letterSpacing:"0.3px"
  },
  emailBtn: {
    background:"transparent",
    color:"#cbd5e1",
    border:"1px solid rgba(148,163,184,0.35)",
    padding:"12px 24px",
    borderRadius:12,
    fontSize:14,
    cursor:"pointer",
    width:"100%",
    marginBottom:12,
    fontFamily:"'Georgia', serif"
  },
  authForm: {
    display:"flex",
    flexDirection:"column",
    gap:8,
    marginBottom:8
  },
  authSwitch: {
    background:"none",
    border:"none",
    color:"#a5b4fc",
    fontSize:12,
    cursor:"pointer",
    padding:2,
    marginTop:2
  },
  authMessage: {
    color:"#94a3b8",
    fontSize:11,
    margin:"2px 0 0 0"
  },
  powered: {color:"#6b7280", fontSize:10, textAlign:"center", marginTop:8, fontStyle:"italic"},
  etfTapeWrap: {
    width:"100%",
    overflow:"hidden",
    backgroundColor:"#04080f",
    border:"1px solid rgba(34,211,238,0.2)",
    borderRadius:10,
    marginBottom:10
  },
  tickerTrack: {
    display:"flex",
    width:"max-content",
    animation:"ticker-scroll 30s linear infinite"
  },
  etfTapeText: {
    color:"#22d3ee",
    fontSize:12,
    fontFamily:"monospace",
    whiteSpace:"nowrap",
    padding:"8px 16px"
  },
  header: {
    display:"flex", justifyContent:"space-between", alignItems:"center",
    marginBottom:16, paddingTop:8, paddingBottom:12,
    borderBottom:"1px solid rgba(255,255,255,0.05)"
  },
  headerTitle: {
    fontSize:17, fontWeight:"bold", color:"#a5b4fc",
    fontFamily:"'Georgia', serif", letterSpacing:"0.5px"
  },
  logoutBtn: {
    backgroundColor:"transparent", color:"#6b7280",
    border:"1px solid rgba(71,85,105,0.4)", padding:"8px 16px",
    borderRadius:8, cursor:"pointer", fontSize:12,
    fontFamily:"'Georgia', serif"
  },
  tab: {
    padding:"10px 4px",
    background:"rgba(15,18,30,0.8)",
    border:"1px solid rgba(255,255,255,0.04)",
    color:"#475569", borderRadius:10, cursor:"pointer", fontSize:16,
    transition:"all 0.2s ease"
  },
  tabActive: {
    background:"linear-gradient(135deg, #4f46e5, #6366f1)",
    color:"#fff",
    border:"1px solid rgba(99,102,241,0.5)",
    boxShadow:"0 4px 15px rgba(99,102,241,0.3)"
  },
  row: {display:"flex", gap:8, marginBottom:8},
  card: {
    background:"linear-gradient(145deg, #0d1117, #111827)",
    borderRadius:18, padding:18, marginBottom:12,
    border:"1px solid rgba(255,255,255,0.06)",
    boxShadow:"0 4px 24px rgba(0,0,0,0.3)"
  },
  cardTitle: {
    fontSize:13, fontWeight:"bold", margin:"0 0 14px 0",
    color:"#94a3b8", textTransform:"uppercase",
    letterSpacing:"1px", fontFamily:"'Georgia', serif"
  },
  label: {color:"#475569", fontSize:10, margin:"0 0 4px 0", textTransform:"uppercase", letterSpacing:"0.8px"},
  bigNum: {fontSize:22, fontWeight:"bold", margin:0, color:"#f1f5f9", fontFamily:"'Georgia', serif"},
  input: {
    width:"100%", padding:"13px 14px", marginBottom:8,
    borderRadius:11, border:"1px solid rgba(255,255,255,0.08)",
    background:"rgba(7,8,15,0.8)", color:"#e2e8f0",
    fontSize:14, boxSizing:"border-box",
    fontFamily:"'Georgia', serif",
    outline:"none"
  },
  addBtn: {
    width:"100%",
    background:"linear-gradient(135deg, #4f46e5, #6366f1)",
    color:"#fff", border:"none", padding:15,
    borderRadius:11, fontSize:15, cursor:"pointer",
    fontWeight:"bold", fontFamily:"'Georgia', serif",
    boxShadow:"0 4px 15px rgba(99,102,241,0.3)",
    letterSpacing:"0.3px"
  },
  posRow: {
    display:"flex", alignItems:"flex-start",
    padding:"14px 0", borderBottom:"1px solid rgba(255,255,255,0.04)"
  },
  posSymbol: {
    fontWeight:"bold", fontSize:15, marginBottom:3,
    color:"#e2e8f0", fontFamily:"'Georgia', serif", letterSpacing:"0.5px"
  },
  posDetail: {color:"#475569", fontSize:11, marginBottom:2, fontFamily:"monospace"},
  badge: {fontSize:10, padding:"3px 9px", borderRadius:20, fontWeight:"bold", letterSpacing:"0.3px"},
  delBtn: {background:"none", border:"none", cursor:"pointer", fontSize:15, padding:4, opacity:0.5},
  empty: {color:"#334155", textAlign:"center", padding:20, fontStyle:"italic", fontSize:13},
  marketRow: {
    display:"flex", alignItems:"center",
    padding:"9px 0", borderBottom:"1px solid rgba(255,255,255,0.04)"
  },
  marketTicker: {flex:1, fontWeight:"bold", fontSize:13, color:"#cbd5e1", fontFamily:"'Georgia', serif", letterSpacing:"0.5px"},
  marketPrice: {marginRight:10, color:"#94a3b8", fontSize:13, fontFamily:"monospace"},
  ocLink: {display:"block", color:"#6366f1", padding:"10px 0", textDecoration:"none", borderBottom:"1px solid rgba(255,255,255,0.04)"},
}
